import { render, staticRenderFns } from "./DetalleTurno.vue?vue&type=template&id=2b1e81e0&scoped=true&"
import script from "./DetalleTurno.vue?vue&type=script&lang=js&"
export * from "./DetalleTurno.vue?vue&type=script&lang=js&"
import style0 from "./DetalleTurno.vue?vue&type=style&index=0&id=2b1e81e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e81e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
